module.exports = __webpack_public_path__ + "static/img/first_gem.ba8fe62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/gem/first_gem.png
// module id = lXLW
// module chunks = 1